export const icons = {
  ADD: 'add',
  SEARCH: 'search',
  CALENDAR: 'calendar_today',
  CLOUD: 'cloud_upload',
  DOWNLOAD: 'cloud_download',
  PREV: 'navigate_before',
  NEXT: 'navigate_next',
  EDIT: 'edit',
  VISIBILITY: 'visibility',
  ERROR: 'error',
  DELETE: 'delete',
  COPY: 'content_copy',
  REMOVE: 'remove_circle',
  CHECK: 'check',
  PERSON_REMOVE: 'person_remove',
  DIVERSITY: 'diversity_3',
}
